// extracted by mini-css-extract-plugin
export default {"box":"mastersFilterPage_box__9TWP4","box__btn":"mastersFilterPage_box__btn__KQ-R6","box__btn__add":"mastersFilterPage_box__btn__add__9XJCO"};